import { supabase } from '@/core/database/supabase';
import type { ScheduleStats } from '../types/construction-schedules.types';

export const ConstructionScheduleStatsService = {
  async getScheduleStats(companyId: string, projectId?: string): Promise<ScheduleStats> {
    let query = supabase
      .from('construction_schedules')
      .select('status_code, scheduled_start_date, scheduled_end_date')
      .eq('company_id', companyId);
      
    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query;
    if (error) throw error;

    const schedules = data || [];
    const todayStr = new Date().toISOString().split('T')[0];
    
    const activeToday = schedules.filter(s => s.scheduled_start_date <= todayStr && s.scheduled_end_date >= todayStr).length;
    const delayed = schedules.filter(s => s.status_code === 'delayed').length;
    const upcoming = schedules.filter(s => s.scheduled_start_date > todayStr).length;
    const completed = schedules.filter(s => s.status_code === 'completed').length;

    return {
      totalScheduled: schedules.length,
      activeToday,
      delayedCount: delayed,
      upcomingCount: upcoming,
      completionRate: schedules.length > 0 ? (completed / schedules.length) * 100 : 0,
    };
  }
};
